import React from 'react';
import styled from 'styled-components';
import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';
import env from '../../env';
import usePageTitle from '../../Common/Hooks/usePageTitle';
import MinimalHeader from '../Components/MinimalHeader';

const Container = styled.div`
  width: 100%;
  padding: 60px 120px;
`;

const StyledTypeform = styled.div`
  height: 135vh;
  width: 100%;
`;

const ExtensionUninstalled: React.FC = () => {
  usePageTitle('Extension Uninstalled');

  const typeformRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (typeformRef.current) {
      // Using the latest createWidget API for Typeform 5.5.0
      const { unmount } = createWidget(env.extension_uninstall_typeform_id, {
        container: typeformRef.current,
        hideFooter: true,
        hideHeaders: true,
        noScrollbars: true, // Updated from hideScrollbars to noScrollbars in v5+
        onSubmit: ({ responseId }: { responseId: string }) => {
          if (typeformRef.current) {
            typeformRef.current.style.height = '50vh';
            typeformRef.current.style.width = '100%';
            typeformRef.current.style.paddingLeft = '0';
          }
        },
        onReady: () => {
          if (typeformRef.current) {
            typeformRef.current.style.paddingLeft = '8%';
            typeformRef.current.style.marginTop = '0';
          }
        },
      });

      // Clean up function
      return () => {
        if (unmount) {
          unmount();
        }
      };
    }
  }, []);

  return (
    <Container>
      <MinimalHeader uninstallHeading />
      <StyledTypeform ref={typeformRef} id="uninstall-survey" />
    </Container>
  );
};

export default ExtensionUninstalled;
